import { useSelector } from "react-redux";
import React, { useState } from "react";
import { useRelativeTime } from "../../../../hooks/useRelativeTime";

import styles from "../../../../styles/Components/new-insight/signals-section/signals-table/SignalCell.module.css";
import { Spin } from "antd";
import { RiExchangeFundsLine } from "react-icons/ri";
import useServiceStatus from "../../../../hooks/useServiceStatus";
import { MdAccessTime } from "react-icons/md";
import HiddenContent from "../../../../ui/HiddenContent";
import { HiOutlineRefresh } from "react-icons/hi";
import RequestLiveSuggestionModal from "../../../../shared/ai-trade-suggestion/RequestLiveSuggestionModal";
import { liveSuggestionFor } from "../../../../redux/live-suggestion/liveSuggestionSlice";

function LiveSignalCell({ coin }) {
  const {
    liveSuggestion: { suggestions, coinStatus, liveTimeframe },
  } = useSelector((state) => state);

  const [showLiveModal, setShowLiveModal] = useState(false);

  const { isActive } = useServiceStatus("insight");

  const liveData = liveSuggestionFor(suggestions, coin, liveTimeframe) || {};

  const { prediction, signal_timestamp: signalTime, confidence } = liveData;

  const showLoading = coinStatus[coin] === "loading" && !prediction;

  const date = useRelativeTime(signalTime || "");
  const error = !liveData?.prediction && coinStatus[coin] === "error";
  const noSignal = !liveData?.prediction;

  return (
    <div
      className={`${styles.container} ${isActive ? styles?.[prediction?.toLowerCase()] : ""} ${noSignal || !isActive ? styles.emptyBox : ""}`}
    >
      {showLoading ? (
        <Spin size="small" />
      ) : error ? (
        <RiExchangeFundsLine
          color="lightgrey"
          style={{ margin: "auto" }}
          size={25}
        />
      ) : isActive ? (
        noSignal ? (
          <span>-</span>
        ) : (
          <div className={styles.signalInfo}>
            <span className={styles.infoItem}>
              Confidence: {confidence?.toPrecision(2)}%
            </span>
            <div className={styles.infoRow}>
              <span className={styles.infoItem}>
                <MdAccessTime />
                {date}
              </span>
              <span
                className={styles.runAiButton}
                style={{ marginLeft: "auto" }}
                onClick={() => setShowLiveModal(true)}
              >
                <HiOutlineRefresh />
                Backtest
              </span>
            </div>
          </div>
        )
      ) : (
        <HiddenContent service="insai" />
      )}

      {isActive && prediction && (
        <span
          className={`${styles.predictionBadge} ${styles?.[prediction?.toLowerCase()]}`}
        >
          {prediction}
        </span>
      )}

      {showLiveModal && (
        <RequestLiveSuggestionModal
          show={showLiveModal}
          setShow={setShowLiveModal}
          coin={coin?.split("/USDT")?.[0]}
        />
      )}
    </div>
  );
}

export default LiveSignalCell;
